<div class="landing-shell" [class.login-open]="loginOpen()">
<div class="landing-content landing" [class.lang-hi]="lang() === 'hi'">
  <div class="a11y-strip" role="region" [attr.aria-label]="pick('Accessibility tools', 'पहुंच उपकरण')">
    <div class="wrap a11y-inner">
      <nav class="a11y-links" [attr.aria-label]="pick('Page links', 'पृष्ठ लिंक')">
        <a href="#main-content" class="a11y-link">
          <span class="a11y-full">{{ pick(COPY.skipLink.en, COPY.skipLink.hi) }}</span>
          <span class="a11y-short">{{ pick('Skip', 'छोड़ें') }}</span>
        </a>
        <span class="a11y-sep" aria-hidden="true">·</span>
        <a href="#main-content" class="a11y-link">
          <span class="a11y-full">{{ pick(COPY.screenReader.en, COPY.screenReader.hi) }}</span>
          <span class="a11y-short">{{ pick('Screen reader', 'स्क्रीन रीडर') }}</span>
        </a>
      </nav>
      <div class="a11y-tools">
        <button type="button" class="a11y-btn" (click)="fontDown()" [attr.aria-label]="pick('Decrease font size', 'फ़ॉन्ट घटाएँ')">A−</button>
        <button type="button" class="a11y-btn" (click)="fontReset()" [attr.aria-label]="pick('Reset font size', 'फ़ॉन्ट रीसेट')">A</button>
        <button type="button" class="a11y-btn" (click)="fontUp()" [attr.aria-label]="pick('Increase font size', 'फ़ॉन्ट बढ़ाएँ')">A+</button>
        <button
          type="button"
          class="a11y-btn a11y-contrast"
          (click)="toggleContrast()"
          [attr.aria-pressed]="highContrast()"
          [attr.aria-label]="pick(COPY.highContrast.en, COPY.highContrast.hi)"
        >
          <span class="a11y-full">{{ pick(COPY.highContrast.en, COPY.highContrast.hi) }}</span>
          <span class="a11y-short" aria-hidden="true">◐</span>
        </button>
      </div>
    </div>
  </div>

  <header class="masthead">
    <div class="wrap masthead-inner">
      <a routerLink="/" class="brand-block" [attr.aria-label]="pick('PDA home', 'PDA होम')">
        <img class="emblem-img" [src]="logoUrl" width="56" height="56" alt="Prayagraj Development Authority (PDA) Logo" />
        <div class="brand-text">
          <p class="gov-sub">{{ pick('Government of Uttar Pradesh', 'उत्तर प्रदेश सरकार') }}</p>
          <p class="org-name">{{ pick(ORG.fullName.en, ORG.fullName.hi) }}</p>
          @if (lang() === 'en') {
            <p class="org-alt hi-line">{{ ORG.fullName.hi }}</p>
          } @else {
            <p class="org-alt">{{ ORG.fullName.en }}</p>
          }
        </div>
      </a>

      <div class="masthead-actions">
        @if (session.loggedIn()) {
          <div class="session-wrap">
            <div class="session-dropdown-wrap">
              <button
                type="button"
                class="session-chip session-chip--trigger"
                (click)="toggleSessionMenu($event)"
                [attr.aria-expanded]="sessionMenuOpen()"
                aria-haspopup="menu"
                [attr.aria-label]="pick('Account menu', 'खाता मेनू')"
              >
                <span class="signed-dot" aria-hidden="true"></span>
                <strong class="session-name">{{ session.displayName() }}</strong>
                <span class="session-chevron" aria-hidden="true">▾</span>
              </button>

              @if (sessionMenuOpen()) {
                <div class="session-menu" role="menu">
                  <button type="button" role="menuitem" (click)="onPortalFromMenu()">
                    {{ pick(COPY.portal.en, COPY.portal.hi) }}
                  </button>
                  <button type="button" role="menuitem" class="session-menu-signout" (click)="onSignOutFromMenu()">
                    {{ pick(COPY.signOut.en, COPY.signOut.hi) }}
                  </button>
                </div>
              }
            </div>

            <div class="lang-toggle lang-toggle--stacked" role="group" [attr.aria-label]="pick('Language', 'भाषा')">
              <button type="button" [class.active]="lang() === 'en'" (click)="setLang('en')">EN</button>
              <button type="button" [class.active]="lang() === 'hi'" (click)="setLang('hi')">हिं</button>
            </div>
          </div>
        } @else {
          <div class="lang-toggle" role="group" [attr.aria-label]="pick('Language', 'भाषा')">
            <button type="button" [class.active]="lang() === 'en'" (click)="setLang('en')">EN</button>
            <button type="button" [class.active]="lang() === 'hi'" (click)="setLang('hi')">हिं</button>
          </div>
        }
      </div>
    </div>
  </header>

  <main id="main-content">
    <section class="hero" aria-labelledby="hero-title">
      <div
        class="hero-media"
        style="background-image: url('/assets/landing/hero-sangam.jpg')"
        role="img"
        [attr.aria-label]="pick('Triveni Sangam, Prayagraj', 'त्रिवेणी संगम, प्रयागराज')"
      ></div>
      <div class="hero-overlay" aria-hidden="true"></div>
      <div class="wrap hero-inner">
        <span class="location-pill">{{ pick(COPY.locationTag.en, COPY.locationTag.hi) }}</span>
        <h1 id="hero-title" class="hero-title">{{ pick(COPY.heroTitle.en, COPY.heroTitle.hi) }}</h1>
        <p class="hero-sub">{{ pick(COPY.heroSub.en, COPY.heroSub.hi) }}</p>
        <div class="hero-cta">
          <button type="button" class="btn btn-primary" (click)="scrollToModules()">
            {{ pick(COPY.modulesCta.en, COPY.modulesCta.hi) }}
          </button>
        </div>
        <p class="trust-line">{{ pick(COPY.trustLine.en, COPY.trustLine.hi) }}</p>
      </div>
    </section>

    <section class="section portal-modules" id="modules-h" aria-labelledby="portal-mod-h">
      <div class="wrap">
        <header class="section-head">
          <h2 id="portal-mod-h">{{ pick(COPY.modulesTitle.en, COPY.modulesTitle.hi) }}</h2>
          <p>{{ pick(COPY.modulesPickerSub.en, COPY.modulesPickerSub.hi) }}</p>
        </header>
        <div class="portal-modules-grid">
          @for (mod of PLATFORM_MODULES; track mod.key) {
            <button
              type="button"
              class="portal-module-card"
              [class.portal-module-card--dms]="mod.key === 'dms'"
              [class.portal-module-card--enforcement]="mod.key === 'enforcement'"
              (click)="openPlatformModule(mod.key)"
              [style.--accent]="domainColor(mod.domain).hue"
              [style.--accent-wash]="domainColor(mod.domain).wash"
            >
              <span class="portal-module-glow" aria-hidden="true"></span>
              <div class="portal-module-header">
                <span class="portal-module-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
                    <path [attr.d]="iconPath(moduleIcon(mod.domain))" />
                  </svg>
                </span>
                <span class="portal-module-badge">{{ pick(mod.badgeEn, mod.badgeHi) }}</span>
              </div>
              <div class="portal-module-body">
                <h3 class="portal-module-title">{{ pick(mod.en, mod.hi) }}</h3>
                <p class="portal-module-desc">{{ pick(mod.descEn, mod.descHi) }}</p>
                <ul class="portal-module-features">
                  @for (feature of mod.features; track feature.en) {
                    <li>{{ pick(feature.en, feature.hi) }}</li>
                  }
                </ul>
              </div>
              <span class="portal-module-cta">
                {{ pick(COPY.modulesOpen.en, COPY.modulesOpen.hi) }}
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.25" aria-hidden="true">
                  <path d="M5 12h14M13 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </button>
          }
        </div>
      </div>
    </section>

    <section class="heritage" aria-labelledby="heritage-h">
      <div class="wrap heritage-inner">
        <div class="heritage-mosaic" aria-hidden="false">
          @for (img of HERITAGE; track img.src) {
            <figure class="heritage-shot">
              <img [src]="img.src" [alt]="pick(img.altEn, img.altHi)" width="640" height="420" loading="lazy" />
            </figure>
          }
        </div>
        <div class="heritage-copy">
          <h2 id="heritage-h" class="sr-only">{{ pick('Prayagraj', 'प्रयागराज') }}</h2>
          <p class="heritage-line">{{ pick(COPY.heritageTitle.en, COPY.heritageTitle.hi) }}</p>
          <p class="heritage-credit">{{ pick(COPY.heritageCredit.en, COPY.heritageCredit.hi) }}</p>
        </div>
      </div>
    </section>

    <div class="flow-divider" aria-hidden="true">
      <svg viewBox="0 0 1200 24" preserveAspectRatio="none">
        <path d="M0,12 C200,4 400,20 600,12 C800,4 1000,20 1200,12" fill="none" stroke="var(--teal)" stroke-width="1.25" opacity="0.45" />
      </svg>
    </div>

    <section class="section how-section" aria-labelledby="how-h">
      <div class="wrap">
        <header class="section-head">
          <h2 id="how-h">{{ pick(COPY.howTitle.en, COPY.howTitle.hi) }}</h2>
        </header>
        <ol class="steps">
          @for (step of STEPS; track step.step; let last = $last) {
            <li>
              <span class="step-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
                  <path [attr.d]="iconPath(stepIcon(step.icon))" />
                </svg>
              </span>
              <div>
                <strong>{{ pick(step.en, step.hi) }}</strong>
                <p>{{ pick(step.subEn, step.subHi) }}</p>
              </div>
              @if (!last) {
                <span class="step-flow" aria-hidden="true"></span>
              }
            </li>
          }
        </ol>
      </div>
    </section>

    <section class="section notices-section" aria-labelledby="notice-h">
      <div class="wrap">
        <header class="section-head">
          <h2 id="notice-h">{{ pick(COPY.noticesTitle.en, COPY.noticesTitle.hi) }}</h2>
        </header>
        <ul class="notices">
          @for (n of NOTICES; track n.date) {
            <li>
              <time [dateTime]="n.date">{{ n.date | date: 'mediumDate' }}</time>
              <p>{{ pick(n.en, n.hi) }}</p>
            </li>
          }
        </ul>
      </div>
    </section>
  </main>

  <footer class="site-footer">
    <div class="wrap footer-grid">
      <div class="footer-col">
        <strong>{{ ORG.shortName }} · Digital Platform</strong>
        <p>{{ pick(ORG.contact.address.en, ORG.contact.address.hi) }}</p>
        <p><a [href]="'tel:' + ORG.contact.phone">{{ ORG.contact.phone }}</a></p>
        <p><a [href]="'mailto:' + ORG.contact.email">{{ ORG.contact.email }}</a></p>
        <p>{{ pick('Helpline', 'हेल्पलाइन') }}: {{ ORG.contact.helpline }}</p>
      </div>
      <div class="footer-col">
        <strong>{{ pick(COPY.footerQuick.en, COPY.footerQuick.hi) }}</strong>
        <a href="#modules-h" (click)="scrollToModules(); $event.preventDefault()">{{ pick(COPY.modulesTitle.en, COPY.modulesTitle.hi) }}</a>
      </div>
      <div class="footer-col">
        <strong>{{ pick(COPY.footerGovLinks.en, COPY.footerGovLinks.hi) }}</strong>
        <a href="https://up.gov.in" target="_blank" rel="noopener">{{ pick(COPY.upGov.en, COPY.upGov.hi) }}</a>
        <a href="https://www.india.gov.in" target="_blank" rel="noopener">{{ COPY.indiaGov.en }}</a>
      </div>
    </div>
    <div class="wrap footer-meta">
      <p>{{ pick(COPY.footerRights.en, COPY.footerRights.hi) }}</p>
      <p>{{ pick(COPY.footerUpdated.en, COPY.footerUpdated.hi) }}: 4 Jul 2026</p>
    </div>
  </footer>
</div>
</div>

@if (loginOpen()) {
  <div class="login-overlay" role="dialog" aria-modal="true" aria-label="Sign in" (click)="closeLogin()">
    <div class="login-overlay-panel" (click)="$event.stopPropagation()">
      <app-login [overlay]="true" [returnUrl]="loginReturnUrl()" (closed)="closeLogin()" />
    </div>
  </div>
}
